var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['ticket-chip-container', _vm.$listeners.click && 'ticket-chip-container-link'],style:({
    gap: _vm.linked === _vm.TicketLinkingEnum.NO_LINKING ? '1.5rem' : '0.75rem',
    borderColor: _vm.selected ? '#666' : '#f5f5f5',
  }),on:{"click":e => _vm.$emit('click', e)}},[_c('div',{staticClass:"label-container"},[_vm._t("left-slot"),_c('span',{staticClass:"label",style:(`${_vm.linked}`)},[_vm._v(_vm._s(_vm.label))]),(_vm.number || _vm.number === 0)?_c('span',{staticClass:"number"},[_vm._v(_vm._s(_vm.number))]):_vm._e()],2),_vm._t("right-slot")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }